// -----------------------------------------------------------------------------
// STICKY HEADER
// -----------------------------------------------------------------------------
/**
 * Handle sticky header behavior on scroll
 */
let lastScroll = 0;

const stickyHeader = () => {
  const header = document.querySelector("header.header");

  if (!header) return;

  header.classList.toggle("scroll", document.documentElement.scrollTop > 0);

  if (header.dataset.hide === "true") {
    const currentScroll = window.scrollY;

    if (currentScroll > lastScroll && currentScroll > 0) {
      header.classList.add("scrolling");
    } else {
      header.classList.remove("scrolling");
    }

    lastScroll = currentScroll;
  }
};

const stickySidebar = () => {
  const header = document.querySelector("header.header");

  if (!header) return;

  const sidebar = document.querySelector(".content__sidebar--inner.sticky");
  const viewport = window.innerHeight - header.clientHeight * 2;

  if (!sidebar) return;

  // Remove sticky class if sidebar is taller than viewport
  if (viewport < sidebar.clientHeight) {
    sidebar.classList.remove("sticky");
    return;
  }

  const sidebarOptions = {
    offset: header ? header.clientHeight : 0
  };

  // Set --offset-top property
  sidebar.style.setProperty("--offset-top", sidebarOptions.offset + "px");
};

export { stickyHeader, stickySidebar };
